module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAF0AAAAWCAYAAACi7pBsAAABN0lEQVRoge2YwQ7CIAyGndlb6UGv+ryevfhecxyaYG2hLWydrl+yMKG07C8w5jDNHIJVOXoPYI+E6A6E6A6E6A40i369nz/Kml2tbg+McCMR4Pl4NQXLY4AvHLc1Ri3eJpgYLrcT10TapHvqouy4OssYJPTy04suolNCSnyVhM+T1srWRDfv6Zqlm9rzvR+u/LfW5y9jEj2Jw4mCRQXAnipxnWU8VBIlfUoTYKkX/Vg3+aYkDtVGJUl66pGOx7JKsJ3Vj5ZVzun4YaAOyh4PBzE0gnMrUuPHQnfRqWWbwEfE2p5uiUsltwQkPO9j8aPFtL2UkL5Uc7va9iO1xTZYzHx8ko+1xWY8d6zRntNrfUq2WzvSLc3IZZ2rt2SemjGlGffvDEl570HsjfiX0YEQ3YEQ3YEQ3YE33YLANTcO2ggAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/SaveFile/bctb1-5.png
// module id = 826
// module chunks = 0